import { Dispatch, SetStateAction, useState } from "react";

export type ISetOpen = {
    on: () => void;
    off: () => void;
};

export type ITypeaheadState = {
    isOpen: boolean;
    selectedIndex: number | null;
    setOpen: ISetOpen;
    setSelectedIndex: Dispatch<SetStateAction<number | null>>;
};
export const useTypeaheadState = (): ITypeaheadState => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

    const setOpen: ISetOpen = {
        on: () => setIsOpen(true),
        off: () => setIsOpen(false),
    };

    return {
        isOpen,
        selectedIndex,
        setOpen,
        setSelectedIndex,
    };
};
